"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.phone = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const phone = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'phone-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { d: 'M16.0934 13.3489C15.9073 12.8836 13.3014 12.1391 13.1153 12.046H12.9291C12.5569 12.2321 12.1846 12.5113 11.347 13.2559C10.4163 12.7905 9.20644 11.6737 8.55497 11.0223C7.9035 10.2777 7.15896 9.06785 6.87976 8.23025C7.81043 7.39264 8.1827 7.02038 8.1827 6.64811C8.1827 6.46197 7.71737 3.76302 7.25203 3.48382L7.15896 3.39075C6.87976 3.20462 6.50749 2.92542 5.94909 3.01849C5.85602 3.01849 5.76295 3.11155 5.57682 3.20462C5.29762 3.39075 4.46001 3.94916 4.08774 4.6937C3.90161 5.15903 3.71548 9.34706 6.87976 12.8836C9.95098 16.4202 13.8598 16.5132 14.4182 16.4202H14.5113C15.2558 16.141 15.9073 15.3964 16.1865 15.1172C16.6518 14.5588 16.2795 13.9073 16.1865 13.5351L16.0934 13.3489Z', fill: '#4B5563' })));
};
exports.phone = phone;
